import { useEffect } from "react";
import Lenis from "lenis";
import { setLenis } from "./lenis";

// Momentum smooth scrolling on desktop only. On touch devices we skip Lenis
// so users get the browser's native, buttery mobile scrolling.
export const useSmoothScroll = () => {
  useEffect(() => {
    const isTouch =
      typeof window !== "undefined" &&
      (("ontouchstart" in window) ||
        window.matchMedia("(pointer: coarse)").matches ||
        window.innerWidth < 900);

    if (isTouch) {
      setLenis(null);
      return undefined;
    }

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    setLenis(lenis);
    if (typeof window !== "undefined") window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);
};

export default useSmoothScroll;
